/**
 * AuditSessionStatusBadge Component
 *
 * Reusable status badge component for audit sessions with consistent styling
 * and color coding across the entire audit domain.
 */

import { formatStatus } from '@internal-audit/shared/utils/formatHelpers';
import { Badge, BadgeVariant } from '@soteria/design-system-ve';

interface AuditSessionStatusBadgeProps {
  status: string;
  className?: string;
}

// Helper function to get status badge variant
function getStatusVariant(status: string): BadgeVariant {
  switch (status.toLowerCase()) {
    case 'active':
    case 'in_progress':
      return BadgeVariant.Pending; // Grey for In Progress
    case 'completed':
      return BadgeVariant.Approved; // Green for Completed
    case 'expired':
    case 'pending':
    case 'skipped':
      return BadgeVariant.Error; // Red for Expired/Pending/Skipped
    default:
      return BadgeVariant.Pending;
  }
}

export function AuditSessionStatusBadge({ status, className }: AuditSessionStatusBadgeProps) {
  const variant = getStatusVariant(status);

  return <Badge className={className} text={formatStatus(status)} variant={variant} />;
}
